import { useState, useRef, useEffect } from "react";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const currentLang = i18n.language?.startsWith("ar") ? "ar" : "en";

  const languages = [
    { code: "en", label: "EN", nativeLabel: "English" },
    { code: "ar", label: "AR", nativeLabel: "العربية" },
  ];

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const switchLang = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-3 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap"
        aria-label="Switch language"
      >
        <i className="ri-global-line"></i>
        <span>{currentLang === "ar" ? "AR" : "EN"}</span>
        {open ? (
          <i className="ri-arrow-up-s-line text-xs"></i>
        ) : (
          <i className="ri-arrow-down-s-line text-xs"></i>
        )}
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-1 bg-background-50 border border-background-200 rounded-lg py-1 min-w-[140px] z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => switchLang(lang.code)}
              className={`w-full text-left px-4 py-2.5 text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center justify-between ${
                currentLang === lang.code
                  ? "text-primary-600 bg-primary-50 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span>{lang.nativeLabel}</span>
              {currentLang === lang.code && (
                <i className="ri-check-line text-primary-500"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}